import { AxiosError } from "axios";

interface IErrorCodeHandlers {
	[errorCode: number]: (error: AxiosError | string) => void;
}

interface IGeneralRequestErrorHandlerConfig {
	errorCodeHandlers?: IErrorCodeHandlers;
}

const generalRequestErrorHandler = (
	error: AxiosError | string,
	config?: IGeneralRequestErrorHandlerConfig
): void => {
	const userErrorCodeHandlers = config?.errorCodeHandlers || {};

	console.error("General API Error:", error);

	if (
		typeof error === "object" &&
		error !== null &&
		"isAxiosError" in error &&
		error.isAxiosError
	) {
		const axiosError = error;
		const statusCode = axiosError.response?.status;

		if (statusCode && userErrorCodeHandlers[statusCode]) {
			userErrorCodeHandlers[statusCode](axiosError);
		}

		if (statusCode === 401) {
			console.warn("General - Unauthorized:", axiosError.message);
		} else if (statusCode === 404) {
			console.error("General - Not Found:", axiosError.message);
		} else if (axiosError.response) {
			console.error("Response Status:", statusCode, axiosError.response.data);
		} else if (axiosError.request) {
			console.error("No Response:", axiosError.request);
		} else {
			console.error("Request Setup Error:", axiosError.message);
		}
	} else {
		console.error("Unexpected Error:", error);
	}
};

export default generalRequestErrorHandler;
